export default {
	feedbackBar: {
		buttons: {
			no: 'No',
			yes: 'Yes',
		},
		heading: 'Service history feedback',
		question: 'Is the updated service history format helpful?',
		subheading: 'This is a new feature - your feedback will help us improve its accuracy.',
	},
	form: {
		freeformEntry: 'Add details here',
		heading: 'Let us know why this wasn’t helpful',
		reasons: {
			incorrectDetails: 'Service details pulled are incorrect',
			isMissing: 'Missing one or more service entry',
			someOtherFeedback: 'Something else',
			wrongCategory: 'Service history was categorised incorrectly',
			wrongGap: 'Manufacturer service intervals are incorrect',
		},
		submit: 'Submit feedback',
	},
	toast: {
		error: 'Something went wrong reporting your feedback. Please try again later.',
		success: {
			content: 'We’ll use your feedback to help improve this feature.',
			heading: 'Feedback submitted',
		},
	},
	trigger: 'Feedback?',
};
